import { Box, Typography } from "@mui/material";
import styles from "./services.module.scss";

const Charter = () => {
  return (
    <Typography className={styles.summary}>
      In recognition of contribution by Senior Community in promotion of Hindu
      community wellbeing, culture and tradition, HCCC established the “Golden
      Ager’s Hindu Community Committee” as Strategic Standing Committee here in
      synonymous with and referred as “GASSC”, to prioritize and guide the
      much-needed Services at their golden age, Daily Living, Legal and as well
      as Financial within in the means.
    </Typography>
  );
};

const OurMission = () => {
  return (
    <Typography className={styles.summary}>
      In recognition of contribution by Senior Community in promotion of Hindu
      community wellbeing, culture and tradition, HCCC established the “Golden
      Ager’s Hindu Community Committee” as Strategic Standing Committee here in
      synonymous with and referred as “GASSC”, to prioritize and guide the
      much-needed Services at their golden age, Daily Living, Legal and as well
      as Financial within in the means.
    </Typography>
  );
};

const Objectives = () => {
  return (
    <Typography className={styles.summary}>
      To look in to existing Senior services with avenues of updating along with
      incorporating. Other needed services derived from input on the portal of
      GAHC on HCCC Web Site. The Website of this Comte.” GASSC “is to facilitate
      communication among same age groups of Different backgrounds get together,
      help and assist each other. The services to be achievable and sustainable.
      Moreover, make them feel appreciated and be proud of their contribution in
      sharing of their experience and knowledge to the younger generation.
    </Typography>
  );
};

const OurGoals = () => {
  return (
    <Typography className={styles.summary}>
      <ul style={{paddingRight:0,margin:0}}>
        <li>
          Establish a website including services and contact information for
          specific services available.
        </li>
        <li>
          Establish a roster of members to sign in to the website for assistance
          and as a channel of communication.
        </li>
        <li>
          Establish a roster of individual volunteers with special talents
          and/or resources willing to contribute to the community at large.
        </li>
        <li>
          Look into community needs met with existing avenues and reassess to
          promote or be a part of them.
        </li>
        <li>
          Identify other locations beyond SVT close to their vicinity to assist
          their needs and identify a place for getting together.
        </li>
        <li>
          Develop information and sources for their needs, including advisory
          services such as retirement planning, financial management, estate
          planning, avenues of funeral services, tax services, health
          directives, nutritional support services, health checkup services, and
          information on the management of health and well-being, including
          exercise programs such as yoga and meditation.
        </li>
        <li>
          Raise awareness of avenues and encourage contributions to SVT
          Endowment Funds at their will.
        </li>
      </ul>
    </Typography>
  );
};

const CommitteeMembers = () => {
  return (
    <ol className={styles.summary} style={{paddingRight:0,margin:0}}>
      <li>Dr. Peraiah Sudanagunta (Chairman)</li>
      <li>Dr. Kamala Shankar</li>
      <li>Mr. Bala Mani</li>
      <li>Mr. Kamlesh Jain</li>
      <li>Mr. Kumar Padmini</li>
      <li>Mr. Anand Gundu (Board Liaison)</li>
    </ol>
  );
};

const CommitteeDetails = () => {
  return (
    <Typography className={styles.summary}>
      GASSC met on 5th.Dec,2017 and elected Dr. Peraiah Sudanagunta as chairman
      and Dr. Kamala Shankar as Vice Chairman.This committee has the goal to
      strategically plan and improve services for Seniors of Hindu heritage in
      Bay area.Historical perspective- HCCC Senior activities/ program under
      Human services;HCCC Human services has conducted various activities
      involving senior devotees. In 2007 Board of Directors initiated Senior
      activity program lead by Dr Kamala Shankar and Coordinated by Smt. Savitha
      Setlur. Over the years the program evolved under Human services EC lead by
      many coordinators, Mr. Anand Gundu, Smt. Suman Jain, Smt. Dharini
      Baskaran, Smt. Padmaja Madhusudan. The program /activities have continued
      namely: Yearly seniors day, Yearly bus trips, Volunteering at the temple,
      Senior activity program twice monthly ongoing for10 years, Arts/crafts
      activities, Bhagavat Gita discussion - Yoga/exercise and Socialization
      etc.
    </Typography>
  );
};

const GoldenAgersOverview = () => {
  return (
    <Box className={styles.GoldenAgersOverviewContainer}>
      <Box>
        <Typography className={styles.heading}>Charter</Typography>
        {Charter()}
      </Box>

      <Box>
        <Typography className={styles.heading}>Our Mission</Typography>
        {OurMission()}
      </Box>
      <Box>
        <Typography className={styles.heading}>Objectives</Typography>
        {Objectives()}
      </Box>
      <Box>
        <Typography className={styles.heading}>Our Goals</Typography>
        {OurGoals()}
      </Box>
      <Box>
        <Typography className={styles.heading}>Historical</Typography>
        {CommitteeMembers()}
        {CommitteeDetails()}
      </Box>
    </Box>
  );
};

export default GoldenAgersOverview;
